module.exports = __webpack_public_path__ + "static/media/img.cfc6270f.jpg";